export default value => moment(value).format(FORMAT_DATE)
